<template>

    <div class="custom-modal custom-modal-sm"
         @click="closeCustomModal()">

        <div class="custom-modal-window" style="min-height: 470px;" @click.stop>
            <div class="btn-close" @click="closeCustomModal()"></div>
            <div v-if="fetcher.initialized">

                <h2 v-if="manager.invited_at">#{{ manager.id }} {{ manager.name }}</h2>
                <h2 v-else>Lägg till konto</h2>

                <div class="custom-form-section">

                    <input-text
                        name="name"
                        label="Namn"
                        v-model="manager.name"
                    />

                    <input-text
                        type="email"
                        name="email"
                        label="E-postadress"
                        v-model="manager.email"
                    />

                    <input-select
                        name="type"
                        label="Behörighet"
                        v-model="manager.type"
                        :options="[
                            {value: 'admin', label: 'Administratör'},
                            {value: 'regular', label: 'Användare'},
                        ]"
                    />

                </div>

                <div class="d-flex justify-content-end" v-if="manager.invited_at">
                    <button class="btn btn-primary" @click="patcherPatch()" :disabled="patcher.submitted">
                        <span class="spinner-border spinner-border-sm"></span>
                        Spara
                    </button>
                </div>

                <div class="d-flex justify-content-end" v-if="!manager.invited_at">
                    <button class="btn btn-primary" @click="patcherPatch()" :disabled="patcher.submitted">
                        <span class="spinner-border spinner-border-sm"></span>
                        Spara och bjud in
                    </button>
                </div>

            </div>

            <div v-else>

                <h2>Laddar...</h2>

                <div class="w-100 d-flex justify-content-center align-items-center" style="min-height: 300px;">

                    <div class="spinner-border text-info" style="color:#999!important;" role="status"></div>

                </div>

            </div>

        </div>
    </div>

</template>

<script>

import fetcher from '../../../../shared/mixins/fetcher'
import patcher from '../../../../shared/mixins/patcher'
import modaler from '../../../../shared/mixins/modaler'

export default {

    mixins: [
        fetcher,
        patcher,
        modaler
    ],

    props: {
        manager_id: {
            required: true
        }
    },

    data () {
        return {
            manager: null,
            fetcher: {
                autoFill: [
                    'manager'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/managers/' + this.manager_id
        },

        patcherUrl () {
            return '/managers/' + this.manager_id
        },

        patcherData () {
            return {
                name: this.manager.name,
                email: this.manager.email,
                type: this.manager.type
            }
        }
    },

    methods: {
        patcherSuccess () {
            this.$emit('refresh')
            this.$emit('close')
            setTimeout(function () {
                jQuery('html').removeClass('modal-open')
            }, 360)

            if (!this.manager.invited_at) {
                bus.$emit(
                    'notify',
                    'Kontot har sparats och inbjudan har skickats'
                )
            } else {
                bus.$emit(
                    'notify',
                    'Kontot har sparats'
                )
            }
        }
    }
}
</script>
